/**
 * http://ecma-international.org/ecma-402/7.0/index.html#sec-canonicalizelocalelist
 * @param locales
 */
export function CanonicalizeLocaleList(locales) {
    // TODO
    return Intl.getCanonicalLocales(locales);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formatjs/intl/node_modules/@formatjs/ecma402-abstract/lib/CanonicalizeLocaleList.js
// module id = 485
// module chunks = 7